<template>
  <div class="acc-panel">
    <dl v-if="acc" class="acc-dl mb-0">
      <dt class="acc-dt">{{ t('accommodationHotelNameLabel') }}</dt>
      <dd class="acc-dd">{{ display(acc.name) }}</dd>
      <dt class="acc-dt">{{ t('masterAccommodationCompareAddress') }}</dt>
      <dd class="acc-dd">{{ display(acc.address) }}</dd>
      <dt class="acc-dt">{{ t('masterAccommodationCompareCountryCity') }}</dt>
      <dd class="acc-dd">{{ display(acc.cuntry_and_city) }}</dd>
      <dt class="acc-dt">{{ t('attractionEditingImageLabel') }}</dt>
      <dd class="acc-dd acc-dd-image">
        <img
          v-if="acc.image"
          :src="acc.image"
          :alt="acc.name || 'Accommodation'"
          class="compare-thumb"
        >
        <span v-else>{{ display(acc.image) }}</span>
      </dd>
      <dt class="acc-dt">{{ t('accommodationFreeTextLabel') }}</dt>
      <dd class="acc-dd acc-dd-multiline">{{ display(acc.text) }}</dd>
      <dt class="acc-dt">{{ t('website') }}</dt>
      <dd class="acc-dd">
        <a v-if="acc.link" :href="acc.link" target="_blank" rel="noopener noreferrer">{{ acc.link }}</a>
        <span v-else>{{ display(acc.link) }}</span>
      </dd>
    </dl>
    <p v-else class="text-muted mb-0">{{ t('masterAccommodationCompareEmpty') }}</p>
  </div>
</template>

<script>
import { translationMixin } from '@/mixins/translationMixin';

export default {
  name: 'AccommodationComparePanel',
  mixins: [translationMixin],
  props: {
    acc: {
      type: Object,
      default: null,
    },
  },
  methods: {
    display(val) {
      if (val === null || val === undefined || val === '') {
        return this.t('masterAccommodationCompareEmpty');
      }
      return String(val);
    },
  },
};
</script>

<style scoped>
.acc-dl {
  text-align: inherit;
}
.acc-dt {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #666;
  margin-bottom: 2px;
  margin-top: 10px;
}
.acc-dt:first-child {
  margin-top: 0;
}
.acc-dd {
  font-size: 15px;
  color: #1e1e1e;
  margin-bottom: 0;
  word-break: break-word;
}
.acc-dd-multiline {
  white-space: pre-wrap;
}
.acc-dd-image {
  margin-top: 4px;
}
.compare-thumb {
  display: block;
  max-width: 100%;
  max-height: 160px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
}
</style>
